var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.series)?_c('apex-chart',{staticClass:"donut-chart",attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }